module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_plan_included_04_black-9ba66bf20c870a594ce8c062ccad453e.png";